<template>
    <v-dialog v-model="confirmDialog" max-width="500" persistent>
        <v-card>
            <v-card-title class="headline">
                <slot name="title">{{title}}</slot>
            </v-card-title>
            <v-card-text>
                <slot name="message">{{message}}</slot>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="onConfirm">
                    Yes
                </v-btn>
                <v-btn color="green darken-1" text @click="confirmDialog = false">
                    No
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: {
        title: String,
        message: String,
        value: Boolean
    },

    data: () => ({

    }),

    methods: {
        onConfirm() {
          this.$emit('confirmDelete')
          this.confirmDialog = false
        }
    },

    computed: {
        confirmDialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>